import React, {createRef, useState} from "react";
import styles from './FJSearch.module.less';
import InlineSVG from "react-inlinesvg";
import SearchIcon from '../../../../../icon/search.svg';
import classNames from 'classnames';
import FJSearchCloseIcon from "./FJSearchCloseIcon";
import FJSearchSort from "./FJSearchSort";
import FJSearchHistory from "./FJSearchHistory";

function FJSearch(props) {

  const {
    onSortChange,
    onChange,
    onSubmit,
    onClearHistory,
    isElement,
    value,
    history = [],
    sortType,
    placeHolder,
    couldSort,
    videoStyle,
    musicStyle,
    photoStyle,
    onClear,
  } = props;

  const [inputValue, updateInputValue] = useState('');
  const [isFocus, updateFocus] = useState(false);
  const [prePropsValue, updatePrePropsValue] = useState(value);
  const _updateInputValue = (value) => {
    onChange(value);
    updateInputValue(value);
  };
  const sortComponent = createRef();
  const inputRef = createRef();
  const _onSubmit = (submitValue) => {
	  inputRef.current.blur();
	  onSubmit(submitValue);
  };
  const onInputChange = (e) => {
    let value = e.target.value;
    _updateInputValue(value);
  };
  const onInputKeyDown = (e) => {
    switch (e.keyCode) {
      case 13:
      	if (inputValue.trim() === '') {
          _updateInputValue('');
	      } else {
		      _onSubmit(inputValue);
	      }
        break;
      default:
        break;
    }
  };
  const onBlur = (e) => {
    updateFocus(false);
  };
  const onFocus = () => {
    updateFocus(true);
  };
  const onHandleSortChange = (type) => {
    sortComponent.current.hideDropDown();
    onSortChange(type);
  }
  const clear = () => {
    _updateInputValue('');
    onClear();
  }

	if (prePropsValue !== value) {
		updatePrePropsValue(value);
    _updateInputValue(value);
	}

  let visible = inputValue !== '';

  return (
    <div className={classNames(styles.search_container, {[styles.video_search]: videoStyle || musicStyle}, {[styles.photo_search]: photoStyle})}>
      <InlineSVG src={SearchIcon} className={styles.c_search_container_svg}/>
      <input value={inputValue}
             className={classNames(styles.input_container, {[styles.c_sort_input]: couldSort}, {[styles.c_element_input]: isElement})}
             ref={inputRef}
             onBlur={onBlur}
             onFocus={onFocus}
             onChange={onInputChange}
             onKeyDown={onInputKeyDown}
             placeholder={placeHolder}
      />
      <FJSearchCloseIcon visible={visible}
                         couldSort={couldSort}
                         clear={clear}
      />
      {
        couldSort && (
          <>
            <i className={classNames(styles.c_search_divider, {[styles.video_height]: videoStyle}, {[styles.show]: visible})}/>
            <FJSearchSort visible={visible}
                          sortType={sortType}
                          ref={sortComponent}
                          sortChange={onHandleSortChange}
            />
          </>
        )
      }
			{
				!!history.length && (
					<FJSearchHistory active={isFocus}
													 lists={history}
													 onClear={onClearHistory}
													 onSubmit={_onSubmit}
					/>
				)
			}
    </div>
  )
}

export default FJSearch;